import styled from 'styled-components'

export const ContainerOfModal = styled.div<{width?: string, maxHeight?: string}>`
  background-color: #fff;
  width: ${({width}) => width || '600px'};
  border-radius: 1rem;
  padding: 1.5rem;
  max-height: ${({maxHeight}) => maxHeight || '80%'};
  overflow-y: auto;
`

export const ViewContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 1rem;
`

export const ViewItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  span{
    font-size: 15px;
    font-weight: 400;
  }
`

export const FormContainer = styled.form<{columns?: string}>`
  display: grid;
  grid-template-columns: ${({columns}) => columns || '1fr'};
  gap: 1rem;
`

export const InputDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: .3rem;
`

export const Label = styled.label`
  font-size: 15px;
  display: flex;
  align-items: center;
  font-weight: 700;
`

export const Input = styled.input<{isFilled?: boolean}>`
  width: 100%;
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 2.98rem;
  padding: 0 1rem;
  border-radius: 2rem;
  font-size: 15px;
  ${({isFilled}) => isFilled===false && `
    border: 1px solid red;
  `}
`

export const Textarea = styled.textarea`
  resize: vertical;
  max-width: 100%;
  border: none;
  outline: none;
  background-color: #EBEBEB;
  padding: 1rem;
  border-radius: 20px;
  font-size: 15px;
  min-height: 100px;

  &:disabled {
    background-color: #D3D3D3;
    cursor: default;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
`

export const HeaderTitle = styled.h2`
  font-size: 20px;
  display: flex;
  flex-direction: column;
  span {
    font-size: 13px;
    font-weight: 400;
    color: #0090D3;
    padding: 0.5rem 1rem;
    background-color:rgb(234, 246, 255);
    border-radius: 0.5rem;
    cursor: help;
    width: fit-content;
    user-select: none;
  }
`

export const CloseDiv = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;

  &:hover{
    background-color: #F4F4F4;
  }
`


export const BottomDiv = styled.div`
  margin-top: 1rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap:1.5rem;
  span{
    color:red;
  }
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  gap: 1rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #F0F0F0;
  grid-column: 1 / -1;
`

export const Button = styled.button`
  background-color: #0090D3;
  color: #fff;
  padding: .7rem 1.2rem;
  font-weight: 700;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap:.5rem;
  border-radius: 1.5rem;
  user-select: none;
  cursor: pointer;
  border: none;
  outline: none;
  &:disabled{
    opacity: 0.5;
    cursor: not-allowed;
  }
  img{
    width: 1rem;
  }
  &.cancel{
    border: 1px solid #0090D3;
    color: #0090D3;
    background-color: #fff;
  }
  &.inactive{
    color:rgb(202, 202, 202);
    background-color:rgb(145, 145, 145);
    cursor: not-allowed;
  }
`

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: .1rem;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f7fafc;
  }
`

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

export const StyledCheckbox = styled.div<{ checked: boolean }>`
  display: inline-block;
  width: 30px;
  height: 30px;
  background: ${props => props.checked ? '#0090D3' : '#fff'};
  border: 1px solid ${props => props.checked ? '#0090D3' : '#C4C4C4'};
  border-radius: 6px;
  transition: all 0.2s ease;
  position: relative;
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    display: ${props => props.checked ? 'block' : 'none'};
    left: 8px;
    width: 8px;
    top: 4px;
    height: 14px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`